import type { PhotoFilterInput, PhotoTagMode, PhotoVisibility } from '../types'

export type PhotosFilters = {
  capturedFrom: string | null
  capturedTo: string | null
  buildingId: string | null
  floorId: string | null
  trade: string | null
  tagIds: string[]
  tagMode: PhotoTagMode
  uploadedById: string | null
  visibility: PhotoVisibility | null
  usedIn: 'SNAG' | 'MEETING' | null
  search: string
}

export const EMPTY_PHOTOS_FILTERS: PhotosFilters = {
  capturedFrom: null,
  capturedTo: null,
  buildingId: null,
  floorId: null,
  trade: null,
  tagIds: [],
  tagMode: 'ANY',
  uploadedById: null,
  visibility: null,
  usedIn: null,
  search: '',
}

type Scope = { folderId: string | null; includeSubfolders: boolean; albumId: string | null; shareId?: string | null }

/** 'YYYY-MM-DD' (local) -> ISO instant at the start / end of that local day. */
const dayBound = (value: string, end: boolean): string => {
  const [y, m, d] = value.split('-').map(Number)
  return (end ? new Date(y, m - 1, d, 23, 59, 59, 999) : new Date(y, m - 1, d, 0, 0, 0, 0)).toISOString()
}

export function toPhotoFilterInput(f: PhotosFilters, scope: Scope): PhotoFilterInput {
  const out: PhotoFilterInput = {}
  if (scope.folderId && !scope.albumId) {
    out.folderId = scope.folderId
    if (scope.includeSubfolders) out.includeSubfolders = true
  }
  if (scope.albumId) out.albumId = scope.albumId
  if (f.capturedFrom) out.capturedFrom = dayBound(f.capturedFrom, false)
  if (f.capturedTo) out.capturedTo = dayBound(f.capturedTo, true)
  if (f.buildingId) out.buildingId = f.buildingId
  if (f.floorId) out.floorId = f.floorId
  if (f.trade) out.trade = f.trade
  if (f.tagIds.length > 0) {
    out.tagIds = f.tagIds
    out.tagMode = f.tagMode
  }
  if (f.uploadedById) out.uploadedById = f.uploadedById
  if (f.visibility) out.visibility = f.visibility
  if (f.usedIn) out.usedIn = f.usedIn
  if (scope.shareId) out.shareId = scope.shareId
  if (f.search.trim()) out.search = f.search.trim()
  return out
}

/** Filters living in the dialog (building, floor and search are inline controls, not counted). */
export function activeFilterCount(f: PhotosFilters): number {
  return [
    f.capturedFrom || f.capturedTo,
    f.trade,
    f.tagIds.length > 0,
    f.uploadedById,
    f.visibility,
    f.usedIn,
  ].filter(Boolean).length
}
